import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { DeleteWorkInviteParams } from '@/features/work/api/delete-work-invite/request';
import { deleteWorkInvite } from '@/features/work/api/delete-work-invite/request';

export const useDeleteWorkInviteMutation = (
  settings?: MutationSettings<DeleteWorkInviteParams, typeof deleteWorkInvite>
) =>
  useMutation({
    mutationKey: ['DeleteWorkInvite'],
    mutationFn: ({ params, config }) =>
      deleteWorkInvite({
        params,
        config
      }),
    ...settings?.options
  });
